export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./app.vue?vue&type=template&id=ea805cd2&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/calendar/app.vue?vue&type=template&id=ea805cd2&scoped=true&
// module id = 327
// module chunks = 2